
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.4782 10.7749L19.2645 4H17.893L12.8702 9.88229L8.85648 4H4.22791L10.2965 12.896L4.22791 20H5.59933L10.9045 13.7874L15.1433 20H19.7719L13.4782 10.7749ZM11.6005 12.9737L10.9856 12.088L6.09305 5.04H8.19933L12.1468 10.728L12.7616 11.6137L17.8942 19.008H15.7879L11.6005 12.9737Z","fill":"#16171F"}})])
          )
        }
      }
    